import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'soe-title',
  templateUrl: './soe-title.component.html',
  styleUrls: ['./soe-title.component.scss']
})
export class SoeTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
